import React from 'react';
import heroImage from '../assets/images/hero5.png';


const ApolloHero = ({ onScrollNext }) => {
    return (
        <section className="relative w-full h-[90vh] md:h-[90vh] lg:h-[130vh] overflow-hidden text-white bg-black">
            {/* Hero background image */}
            <img
                src={heroImage}
                alt="Apollo Hero"
                className="absolute top-0 left-0 w-full h-full  z-0"
            />

            {/* Navbar */}
            <nav className="w-full z-30 px-6 py-4 flex justify-between items-center backdrop-blur-sm bg-black/40 text-white">
                <h2 className="text-lg font-bold tracking-wider">Because Science</h2>
                <div className="hidden md:flex space-x-6 text-sm uppercase font-medium">
                    <a href="#moon" className="hover:underline">Going Back to the Moon</a>
                    <a href="#struck" className="hover:underline">Moon Struck</a>
                    <a href="#learned" className="hover:underline">What We Learned from Apollo</a>
                    <a href="#hope" className="hover:underline">What We Hope to Find</a>
                    <a href="#day" className="hover:underline">Day on the Moon</a>
                    <a href="#artemis" className="hover:underline">Apollo vs Artemis</a>
                </div>
            </nav>

            {/* Main Content */}
            <div className="relative z-10 flex flex-col items-center mt-12 lg:mt-36 h-screen  text-center px-6">
                <h1 className="text-3xl md:text-5xl font-extrabold uppercase leading-tight drop-shadow-lg">
                    What We Learned <br />
                    <span className="text-white/90">from Apollo</span>
                </h1>
                <p className="mt-4 max-w-lg text-sm text-white/80 drop-shadow">
                    10 images that forever changed our understanding of the moon.
                </p>
                <div className="mt-6 max-w-md text-sm text-white/70 leading-relaxed text-left">
                    <p className="mb-4">
                        For all of humanity, the moon was a distant, fixed, unreachable object. But all of that changed in the 1960s and ’70s during the space race. The Apollo missions were our first comprehensive attempt to understand our closest galactic neighbor.

                        We sent rovers. We sent people. We sent orbiters. The Russians even sent...tortoises? And we documented everything with the latest and greatest photo and video technology of the time.

                        But what did we actually learn about the moon that we didn’t know before? To answer that, we asked our dear friend and planetary volcanologist Dr. David Williams to show us his favorite Apollo-era photos.
                    </p>
                </div>
            </div>

            {/* Scroll arrow */}
            <div
                onClick={onScrollNext}
                className="absolute bottom-6 left-1/2 -translate-x-1/2 z-20 cursor-pointer animate-bounce text-2xl text-white"
            >
                ↓
            </div>
            {/* Fade from moon to brown background */}

        </section>
    );
};

export default ApolloHero;
